import { Row, Col, Tag } from "antd";
import { useDispatch } from "react-redux";
import BulkActionsMenu from "@components/drop-downs/BulkActionsMenu";
import { MappingRefreshWidget } from "@/components/widgets";
import { ITagMappingStats } from "@/ts/common-types";

interface MappingHeaderProps {
    title: string;
    gridApi: any;
    gridLoading: boolean;
    filterModel: Record<string, any>;
    tagsMappingStats: ITagMappingStats;
    bulkActionData: any[];
    onFilterModelUpdate: any;
    onShowStatusModal: () => void;
    isRefreshEnabled: boolean;
}

const MappingHeader = ({
    title,
    gridApi,
    gridLoading,
    filterModel,
    tagsMappingStats,
    bulkActionData,
    onFilterModelUpdate,
    onShowStatusModal,
    isRefreshEnabled,
}: MappingHeaderProps) => {
    const dispatch = useDispatch();

    return (
        <Row align="middle">
            <Col span={12}>
                <h4>
                    <b>{title}</b>
                </h4>
            </Col>
            <Col span={12}>
                <Row className="px-1" justify="end" gutter={8} wrap={false}>
                    <Col className="px-0">
                        {Object.keys(filterModel).length > 0 && (
                            <div
                                className="btn btn-sm text-primary anchor-class"
                                id="performance-overview-reset-filters-btn"
                                role="button"
                                onClick={() => {
                                    if (gridApi) {
                                        gridApi.setFilterModel({});
                                        dispatch(onFilterModelUpdate({}));
                                    }
                                }}
                            >
                                Reset Filters
                            </div>
                        )}
                    </Col>
                    <Col className="px-2">
                        {!gridLoading &&
                            gridApi &&
                            isRefreshEnabled &&
                            gridApi.getDisplayedRowCount() > 0 && (
                                <MappingRefreshWidget />
                            )}
                    </Col>
                    <Col className="d-flex align-items-center px-0">
                        {!gridLoading && gridApi && gridApi.getDisplayedRowCount() > 0 && (
                            <>
                                {/* TODO: migrate this to new arch */}
                                {/* <Tag
                                    className="btn btn-sm d-flex align-items-center rounded-2 mapping-stats-tag me-2"
                                    role="button"
                                    color="processing"
                                    style={{
                                        transition: 'all 0.2s ease',
                                        border: '1px solid #1890ff',
                                        background: '#e6f7ff',
                                        color: '#1890ff'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.background = '#f0f7ff';
                                        e.currentTarget.style.borderColor = '#40a9ff';
                                        e.currentTarget.style.color = '#40a9ff';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.background = '#e6f7ff';
                                        e.currentTarget.style.borderColor = '#1890ff';
                                        e.currentTarget.style.color = '#1890ff';
                                    }}
                                    onClick={onShowStatusModal}
                                >
                                    {`${Number(tagsMappingStats.top_line || 0) === 0 ? '0' : Number(tagsMappingStats.top_line).toFixed(2)}% products are mapped`}
                                </Tag> */}
                                <BulkActionsMenu data={bulkActionData} />
                            </>
                        )}
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};

export default MappingHeader; 